import { IkeCaptureType, IkeToken } from '@ikegps/core-api';
import {
	CollectionModel,
	CollectionModelFieldAnchor,
	CollectionModelFieldHeight,
	CollectionModelFieldImage,
	CollectionModelFieldLocation,
	CollectionModelFieldNumber,
	CollectionModelFieldTrueSize,
	CollectionModelFieldVector,
} from '@ikegps/core-shared';
import { addStyles } from '../../components/theme';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import { Services } from '../../services';
import { CurrentState } from '../../state/page.state';
import { CaptureThumbnail } from '../capture.thumbnail/capture.thumbnail';
import { CSS, Style, THUMBNAIL_SIZE } from './capture.bar.style';

addStyles(Style);

export const CaptureBar = {
	view(collection?: CollectionModel): MithrilVNode {
		if (collection == null) {
			return m('div', { className: CSS.container });
		}

		const seen: { [captureId: string]: boolean } = {};
		// We use these three arrays here to ensure a consistent order of photos when rendering
		const ikePhotos: MithrilVNode[] = [];
		const tagPhotos: MithrilVNode[] = [];
		const otherPhotos: MithrilVNode[] = [];

		collection.forEachField((field) => {
			let isIkePhoto = false;
			let photoBucket: MithrilVNode[];
			if (CollectionModelFieldTrueSize.isTrueSizeField(field)) {
				photoBucket = ikePhotos;
				isIkePhoto = true;
			} else if (CollectionModelFieldImage.isImageField(field)) {
				photoBucket = tagPhotos;
			} else if (
				Services.Token.has(IkeToken.FEATURE_DISPLAY_ALL_PHOTOS) &&
				(CollectionModelFieldHeight.isHeightField(field) ||
					CollectionModelFieldAnchor.isAnchorField(field) ||
					CollectionModelFieldNumber.isNumberField(field) ||
					CollectionModelFieldLocation.isLocationField(field) ||
					CollectionModelFieldVector.isVectorField(field))
			) {
				photoBucket = otherPhotos;
			} else {
				return;
			}

			const captures = field.getOwnedCaptures() || [];
			captures.sort((a, b) => {
				if (a.collectedAt.iso < b.collectedAt.iso) {
					return 1;
				}
				if (a.collectedAt.iso > b.collectedAt.iso) {
					return -1;
				}
				return 0;
			});
			for (const capture of captures) {
				if (!seen[capture.objectId]) {
					const title = `${field.schema.displayName} - ${Services.DateTime.formatDateTime(capture.collectedAt.iso)}`;
					seen[capture.objectId] = true;
					const thumbnail = CaptureThumbnail.view(collection, capture, {
						truesize: capture.type === IkeCaptureType.TRUE_SIZE,
						title,
						selected: CurrentState.inspectedCaptureId === capture.objectId,
						action: () =>
							CurrentState.setInspectedCollection(CurrentState.inspectedCollectionRevision, capture.objectId),
						icon: isIkePhoto,
						size: THUMBNAIL_SIZE,
					});
					photoBucket.push(thumbnail);
				}
			}
		});

		return m('div', { className: CSS.container }, ikePhotos.concat(tagPhotos, otherPhotos));
	},
};
